<template>
    <div>
        <header :class="{ 'head-active': headerActive }">
            <div class="header-con">
                <a class="logo" href="/">
                    <img :src="logo" alt="">
                </a>
                <div class="right-info">
                    <nav>
                        <ul>
                            <li class="" @mouseenter="mouseEnter(0)" @mouseleave="mouseLeave(0)">
                                <a :class="{ stair: true, active: this.activeIndex == '0' }" href="/">首页</a>
                            </li>
                            <li class="" @mouseenter="mouseEnter(1)" @mouseleave="mouseLeave(0)">
                                <a :class="{ 'stair': true, 'active': activeIndex == 1 }">产品中心</a>
                                <div :class="{ 'second': true, 'active2': activeIndex == 1 }">
                                    <!-- <a class="item " href="/product">氢气泄漏检测胶带</a> -->
                                    <router-link class="item" :to="{ name: 'qtape' }">氢气泄漏检测胶带</router-link>
                                    <!-- <a class="item " href="/product/equipment">氨气泄漏检测胶带</a> -->
                                    <router-link class="item" :to="{ name: 'antape' }">氨气泄漏检测胶带</router-link>
                                    <!-- <a class="item " href="/product/equipment2">安全风险管理系统</a> -->
                                    <router-link class="item" :to="{ name: 'safesystem' }">安全风险管理系统</router-link>
                                    <router-link class="item" :to="{ name: 'taijia' }">140MPa超高压宽温域氢气密封性能检测平台</router-link>
                                    <!-- <a class="item " href="/product/equipment2">140兆帕密封检测台架</a> -->
                                </div>
                            </li>

                            <li class="" @mouseenter="mouseEnter(2)" @mouseleave="mouseLeave(0)">
                                <a :class="{ stair: true, active: activeIndex == 2 }"
                                    href="./home?target=solutionTitle">解决方案</a>
                                <!-- <router-link class="item" :to="{name:'home'}">140兆帕密封检测台架</router-link> -->
                                <!-- <div :class="{ second: true, active2: activeIndex == 2 }">
                                <a class="item " href="/about">关于我们</a>
                                <a class="item " href="/news">公司新闻</a>
                            </div> -->
                            </li>
                            <li class="" @mouseenter="mouseEnter('3')" @mouseleave="mouseLeave(0)">
                                <a :class="{ stair: true, active: activeIndex == 3 }" href="./home?target=aboutUs">关于我们</a>
                                <!-- <div :class="{ second: true, active2: activeIndex == 3 }">
                                <a class="item " href="/about">关于我们</a>
                                <a class="item " href="/news">公司新闻</a>
                            </div> -->
                            </li>

                        </ul>
                    </nav>
                </div>
            </div>
        </header>

        <!-- 回到顶部 -->
        <!-- <div class="back-top" :style="{display: 'block', opacity:headerActive?1:0}">
            <i class="el-icon-arrow-up" @click="scrollTop"></i>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'Head',
    components: {

        // import引入的组件需要注入到对象中才能使用
    },
    data() {
        return {
            logo: require('@/assets/img/logo.png'),
            headerActive: false,
            activeIndex: ''
        }
    },
    created() {

    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('scroll', () => {
                if (document.documentElement.scrollTop > 100) {
                    this.headerActive = true
                }
                else {
                    this.headerActive = false
                }
            })
        })

    },
    methods: {
        mouseEnter(index) {
            this.activeIndex = index;
        },
        mouseLeave(index) {

            this.activeIndex = '';
        },
        scrollTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    },
}
</script>

<style scoped lang="less">
header {
    align-items: center;
    position: fixed;
    width: 100%;
    z-index: 20;
    transition: all 0.6s;
    .header-con{
        width: 75%;
        margin: 0 auto;
        line-height: 75px;
    }

    &:hover {
        background-color: #Fff;

        a {
            color: #333 !important;
        }

        a.router-link-exact-active,a:hover {
            color: #2895EA !important;
        }
    }

    .logo {
        width: 147px;
        display: inline-block;
        position: relative;
        img{
            vertical-align: middle;
        }
    }

    .right-info {
        float: right;
        display: flex;
        flex-wrap: wrap;

        nav {
            margin-right: 62px;

            ul {
                display: flex;

                li {
                    .second {
                        height: 0px;
                        padding-top: 0px;
                        margin-top: 0px;
                        padding-bottom: 0px;
                        margin-bottom: 0px;
                        position: absolute;
                        background-color: #f6f6f6;
                        width: 100%;
                        left: 0;
                        top: 75px;
                        text-align: right;
                        overflow: hidden;

                        .item {
                            height: 80px;
                            line-height: 80px;
                            font-size: 15px;
                            color: #666;
                            margin-right: 95px;
                            cursor: pointer;
                        }

                    }

                    .stair {
                        height: 75px;
                        line-height: 75px;
                        color: #fff;
                        font-size: 16px;
                        margin-left: 38px;
                        margin-right: 38px;
                        display: inline-block;
                        position: relative;
                    }

                    .active2 {
                        height: 80px;
                        transition: all 0.5s;
                    }

                    a.stair:after {
                        content: '';
                        position: absolute;
                        bottom: 0px;
                        left: 0px;
                        width: 100%;
                        height: 2px;
                        transform: scaleX(0);
                        background-color: #008cd6;
                        transition: all 0.5s;
                    }

                    a.active:after {

                        transform: scaleX(1);


                    }
                }
            }

        }
    }

}

header.head-active {
    background-color: #Fff;

    a {
        color: #333 !important;
    }
}

.back-top {
    width: 60px;
    height: 60px;
    line-height: 60px;
    background-color: #008cd6;
    text-align: center;
    position: fixed;
    right: 60px;
    bottom: 100px;
    z-index: 5;
    border-radius: 50%;
    box-sizing: content-box;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    -ms-transition: all 0.3s;
    transition: all 0.3s;
    display: none;

    i {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
    }
}</style>



// WEBPACK FOOTER //
// src/components/common/header.vue